var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-detail" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("youtubeChannel.channelDetail"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("youtubeChannel.channelDetailDesc"))),
        ]),
      ]),
      _vm._v(" "),
      _c("a-form", [
        _c("div", { staticClass: "form-wrapper" }, [
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("youtubeChannel.channelName"))),
              ]),
              _vm._v(" "),
              _c("a-input", {
                attrs: {
                  placeholder: _vm.$t("youtubeChannel.channelName"),
                  name: "channelName",
                },
                model: {
                  value: _vm.clone.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "name", $$v)
                  },
                  expression: "clone.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.clone.payload && _vm.clone.payload.youtubeChannelTitle
            ? _c("div", { staticClass: "input-wrapper" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("youtubeChannel.youtubeChannel"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "youtube-channel-info" }, [
                  _vm.clone.payload.youtubeChannelThumbnail
                    ? _c("img", {
                        staticClass: "channel-thumbnail",
                        attrs: {
                          src: _vm.clone.payload.youtubeChannelThumbnail,
                          alt: "Channel Thumbnail",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.clone.payload.youtubeChannelTitle)),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("youtubeChannel.status")))]),
              _vm._v(" "),
              _c("a-switch", {
                model: {
                  value: _vm.clone.enabled,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "enabled", $$v)
                  },
                  expression: "clone.enabled",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "status-label" }, [
                _vm._v(
                  _vm._s(
                    _vm.clone.enabled
                      ? _vm.$t("youtubeChannel.active")
                      : _vm.$t("youtubeChannel.inactive")
                  )
                ),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: { type: "primary", loading: _vm.loading },
                on: { click: _vm.handleSave },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.update")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }